module.exports = __webpack_public_path__ + "media/images/no_image-a92550bcf501237dc18ed6c1a818dbd3.png";